import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router';

interface Props {
  versions: number;
  text: string;
  to: string;
}

const HistoryLink = (props: Props) => {
  const { versions, text, to } = props;

  return (
    <p className="history_link">
      <FontAwesomeIcon icon="history" />
      {` ${versions} version${versions > 1 ? 's' : ''}: `}
      <Link to={to}>
        <span>{text}</span>
      </Link>
    </p>
  );
};

export default HistoryLink;
